import { FloatingPortal } from "@floating-ui/react";

function OptionalPortal({
  children,
  withinPortal,
}: {
  children: React.ReactNode;
  withinPortal?: boolean | HTMLElement;
}) {
  if (withinPortal) {
    return (
      <FloatingPortal
        root={typeof withinPortal !== "boolean" ? withinPortal : undefined}
      >
        {children}
      </FloatingPortal>
    );
  }
  return children;
}

export default OptionalPortal;
